"use client";

import React from "react";
import { ArrowRight, Heart } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DignityInEveryVisit() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="dignity-in-every-visit" className="relative w-full overflow-hidden bg-background pt-24 pb-16 md:pt-32 md:pb-24 lg:pt-40 lg:pb-32">
      {}
      <div className="pointer-events-none absolute top-0 right-0 -translate-y-1/4 translate-x-1/4 opacity-40 blur-[100px]">
        <div className="aspect-square w-[600px] rounded-full bg-secondary/20" />
      </div>
      <div className="pointer-events-none absolute bottom-0 left-0 translate-y-1/4 -translate-x-1/4 opacity-30 blur-[120px]">
        <div className="aspect-square w-[500px] rounded-full bg-primary/10" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="grid items-center gap-12 lg:grid-cols-12 lg:gap-8">
          
          {}
          <div ref={textRef} className={`flex flex-col gap-8 lg:col-span-7 lg:pr-8 transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="inline-flex items-center gap-2 rounded-full bg-primary/5 px-4 py-2 text-sm font-medium text-primary w-fit border border-primary/10">
              <Heart className="size-4 text-secondary" />
              <span>St. Sampson Senior Aid Foundation</span>
            </div>
            
            <h1 className="font-serif text-5xl leading-[1.1] tracking-tight text-primary md:text-6xl lg:text-[5.5rem]">Senior Welfare Visitation Network</h1>
            
            <p className="font-sans text-[22px] leading-relaxed text-foreground/80 max-w-2xl">We are building a volunteer visitation network of compassionate Orthodox Christians and community members to visit isolated seniors to ensure their basic needs are met, and to offer friendship, prayer, and spiritual support, helping prevent crises and honoring their lives.</p>
            
            <div className="flex flex-wrap items-center gap-4 pt-4">
              <Button asChild size="lg" variant="secondary" className="h-14 rounded-full px-8 text-base font-semibold shadow-lg shadow-secondary/20 transition-transform hover:scale-105">
                <Link to="/SeniorAidPortalPage">
                  Refer a Senior
                  <ArrowRight className="ml-2 size-5" />
                </Link>
              </Button>
              
              <Button asChild size="lg" variant="outline" className="h-14 rounded-full border-primary/20 px-8 text-base font-medium text-primary hover:bg-primary/5 hover:text-primary">
                <Link to="/HomePage#our-sacred-mission">
                  Our Mission
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`relative lg:col-span-5 transition-all duration-1000 delay-200 ease-out ${isImageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            {}
            <div className="absolute -inset-4 z-0 rounded-t-[14rem] rounded-b-[3rem] border border-secondary/30 bg-background/50 backdrop-blur-sm hidden md:block" />
            
            {}
            <div className="relative z-10 mx-auto aspect-[4/5] w-full max-w-md overflow-hidden rounded-t-[12rem] rounded-b-3xl shadow-2xl shadow-primary/10 ring-1 ring-border/50">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1590036/img/volunteer_elderly_companionship_portrait.png" alt="A compassionate volunteer sharing a joyful moment with an elderly person at home" className="h-full w-full object-cover transition-transform duration-700 hover:scale-105" />
              
              {}
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-primary/80 via-primary/40 to-transparent p-8 pt-24">
                <p className="font-serif text-xl italic !text-[hsl(210,40%,98%)]">"Cast me not off in the time of old age; forsake me not when my strength faileth."</p>
                <p className="mt-2 text-sm font-medium !text-[hsl(38,92%,50%)]">Psalm 71:9</p>
              </div>
            </div>
            
            {}
            <div className="absolute -right-6 top-1/4 z-20 hidden h-24 w-24 items-center justify-center rounded-full bg-background shadow-xl shadow-primary/5 md:flex border border-border/50">
              <div className="flex h-16 w-16 items-center justify-center rounded-full bg-secondary/10 text-secondary">
                <Heart className="size-8 fill-secondary/20" />
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}